import { render, staticRenderFns } from "./auction-commission.vue?vue&type=template&id=e4ff2eca&"
import script from "./auction-commission.vue?vue&type=script&lang=js&"
export * from "./auction-commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports